const LINKS = {
  HOME: '/home',
  REQUIRED: '/required',
  HISTORY: '/history',
  NEW_COMMERCIAL_REQUEST: '/create-new-commercial-request',
  NEW_CONSUMER_REQUEST: '/create-new-consumer-request',
  CURRENT_REQUESTS: '/current-requests',
  LOAN_APPLICATION_HISTORY: '/loan-application-history',
  PAGE_MISSING: '/404',
  IE_NOT_SUPPORTED: '/ie-not-supported',
  LOGOUT: '/logout',
};

export default LINKS;
